module.exports={
	"Form": "TeamViewManifest",
	"Scope": "Team-View",
	"Descriptors":
	{
		"TeamDetails.Name":
		{
			"Name": "Name",
			"Hash": "Team-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Team-View-Identity",
				"Group": "Team-View-Identity"
			}
		},
		"TeamDetails.Description":
		{
			"Name": "Description",
			"Hash": "Team-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "Team-View-Details",
				"Group": "Team-View-Details"
			}
		},
		"TeamDetails.ParentIDTeam":
		{
			"Name": "Parent Team",
			"Hash": "Team-View-ParentIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Team-View-Details",
				"Group": "Team-View-Details",
				"Entity": "Team",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TeamDetails.IDTeam":
		{
			"Name": "IDTeam",
			"Hash": "Team-View-IDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.GUIDTeam":
		{
			"Name": "GUIDTeam",
			"Hash": "Team-View-GUIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Team-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Team-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Team-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Team-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Team-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Team-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Team-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Team-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Team-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Team-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
